var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"star-rating-container"},_vm._l((_vm.rating),function(rate,index){return _c('BigStar',{key:rate.key,attrs:{"index":index,"rate":rate.value},on:{"change-rate":_vm.onChangeRate}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }